<script setup>
// import { reactive } from 'vue';
import { onMounted, onUnmounted, ref, watch } from 'vue';

// // Store management imports
import { useBreakStore } from '@/stores/break';

// // Utils imports
import { CommunicationUtil } from '@samsung360vr/overlay-app-sdk';

// // Asset imports
import watchNowPng from '@/assets/images/overlays/watch-now.svg';

const storeBreak = useBreakStore();

const isKeyCurrentlyPressed = ref(false);
const hasOptionBeenSelected = ref(false);
const activeIndex = ref(0);
const pressedKey = ref('');

// // Poll handler functions

const keyDownHandler = (e) => {
  // console.log(`You pressed ${e.key}: ${e.code}.`);

  CommunicationUtil.onKeyPressed(e.keyCode);
  isKeyCurrentlyPressed.value = true;
  pressedKey.value = e.key;
};

const keyUpHandler = () => {
  // console.log(`You are no longer pressing ${e.key}: ${e.code}.`);

  isKeyCurrentlyPressed.value = false;
  pressedKey.value = '';
};

// // Poll lifecycle hooks

onMounted(() => {
  document.addEventListener('keydown', keyDownHandler);
  document.addEventListener('keyup', keyUpHandler);
});

onUnmounted(() => {
  document.removeEventListener('keydown', keyDownHandler);
  document.removeEventListener('keyup', keyUpHandler);
});

// // Poll watchers

watch(isKeyCurrentlyPressed, (isKeyCurrentlyPressedNewVal) => {
  if (isKeyCurrentlyPressedNewVal) {
    // console.log('Key is pressed down');
    // console.log(`pressedKey.value: ${pressedKey.value}`);

    if (!hasOptionBeenSelected.value) {
      if (pressedKey.value === 'ArrowDown') {
        // if (activeIndex.value < props.pollOptions.length - 1) {
        if (activeIndex.value < storeBreak.breakOptions.length - 1) {
          activeIndex.value++;
        }
      } else if (pressedKey.value === 'ArrowUp') {
        if (activeIndex.value > 0) {
          activeIndex.value--;
        }
      } else if (pressedKey.value === 'Enter') {
        // console.log(`Button Selected – optionLabel: ${props.pollOptions[activeIndex.value].optionLabel}`);
        console.log(
          `Button Selected – optionLabel: ${storeBreak.breakOptions[activeIndex.value].optionLabel}`,
        );
        // emit('buttonSelected', e);

        buttonSelectHandler();
      }
    }
  }
});

function buttonClickHandler() {
  console.log(`watch now button clicked`);
}
</script>

<template>
  <button class="button" @click="buttonClickHandler">
    <img :src="watchNowPng" class="icon" />
    Watch Now
  </button>
</template>
